import React from "react";

const RoomAnywhereAdvantages = () => {
  const advantages = [
    {
      id: 1,
      title: "Versatility",
      description:
        "RoomAnywhere’s modular design allows it to adapt to various living scenarios, providing both shelter for the homeless and private spaces within homes, offering a more versatile solution than traditional fixed structures.",
    },
    {
      id: 2,
      title: "Portability",
      description:
        "Unlike permanent structures, RoomAnywhere is portable, enabling quick deployment in response to changing needs, whether for homeless shelters or additional private spaces in homes.",
    },
    {
      id: 3,
      title: "Adaptability to Environments",
      description:
        "The design ensures stability in outdoor conditions, making it suitable for stable, unwindy environments, providing a robust solution for both indoor and outdoor use.",
    },
    {
      id: 4,
      title: "Humanitarian Focus",
      description:
        "RoomAnywhere directly addresses the critical issue of homelessness, providing a dignified and secure refuge. Simultaneously, it offers practical solutions for privacy within homes, contributing to improved living conditions.",
    },
    {
      id: 5,
      title: "Quick Assembly and Disassembly",
      description:
        "The modular framework allows for easy and quick assembly, making it a more time-efficient solution compared to constructing traditional shelters or room additions.",
    },
    {
      id: 6,
      title: "Space Efficiency",
      description:
        "RoomAnywhere optimizes space use by offering a private area without the need for permanent construction, making it an efficient solution for joint families or situations requiring additional private spaces.",
    },
    {
      id: 7,
      title: "Community Integration",
      description:
        "By serving both the homeless & households, RoomAnywhere fosters community integration by addressing diverse needs within a given area, promoting a more inclusive & supportive environment.",
    },
    {
      id: 8,
      title: "Eco-Friendly Design",
      description:
        "The use of sustainable and durable materials aligns with environmental considerations, offering a responsible and conscientious alternative to traditional construction methods.",
    },
    {
      id: 9,
      title: "Cost-Effective",
      description:
        "RoomAnywhere’s modular and portable nature can contribute to cost savings compared to permanent construction, providing an effective and economical solution for various housing challenges.",
    },
    {
      id: 10,
      title: "Positive Impact on Well-being",
      description:
        "The invention not only meets practical needs but also contributes to the overall well-being of individuals by providing secure shelter and private spaces, enhancing both physical and mental health.",
    },
  ];

  return (
    <div className="p-4 bg-gray-600 text-white mt-4">
      <h1 className="text-xl font-bold text-center mb-4">
        RoomAnywhere Advantages
      </h1>
      <ul className="space-y-4">
        {advantages.map((advantage) => (
          <li
            key={advantage.id}
            className="border rounded-lg p-4 shadow-md bg-white"
          >
            <h2 className="text-lg font-semibold text-blue-600">
              {advantage.title}
            </h2>
            <p className="text-gray-700 mt-2">{advantage.description}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RoomAnywhereAdvantages;
